<style>

    .link {
        cursor: pointer;
    }

    .container {
        display: flex;
        flex-direction: column;
        height: 100%;
        /* background-color: yellow; */
        position: relative;
    }

    .it {
        width           : 450px;
        display         : flex;
        flex-direction  : column;
        justify-content : center;
        transition      : transform 1s ease;
        position        : absolute;
        top             : 50%;
        margin-top      : -150px;
    }

    .it > * {
        margin: 10px;
    }

    .it i.link {
        font-size: 16pt;
        color: white;
    }

    .hidden, .hideLogin, .hideRegister, .hideReset {
        transform: translateY(-200vh);
    }

    .ui.icon.message {
        width: auto;
    }

    .ui.input.error .ui.label {
        color: #9f3a38 !important;
        /* background-color: #e0b4b4; */
    }

    .ui.corner.label.error {
        display: none;
    }

    .ui.input.error .ui.corner.label.error {
        color: #9f3a38 !important;
        display: inline-block;
    }

    .ui.label {
        background-color: #fff;
        border-right: 1px solid #ddd;
    }

    .register .ui.label {
        width: 110px;
    }

    .created {
        color: white;
    }

    .ui.corner.label.error {
        width: 4em;
    }

    .promo > .ui.label {
        width: 200px;
    }


    @media screen and (max-width: 990px) {
        .it {
            width: 300px;
        }

        .it i.link {
            font-size: 12pt;
        }

        .ui.big.input, .ui.big.button {
            font-size: 12pt;
        }

        .promo > .ui.label {
            width: 180px;
        }
    }

</style>

<script>
    import { fade }     from 'svelte/transition'
    import { validate } from 'email-validator'
    import { post }     from './shared/api'

    export let onLogin
    
    let name       = null
    let email      = null
    let password   = null
    let promo      = null
    let loading    = false
    let reason     = null
    let errors     = {}
    let action     = 'login'
    let loginError = false

    let passwordReset        = false
    let passwordResetError   = false
    let accountCreated       = false
    let accountCreationError = false
    let passwordTooOld       = false

    $: hideAll      = passwordReset || accountCreated
    $: hideLogin    = hideAll || action !== 'login'
    $: hideReset    = hideAll || action !== 'reset'
    $: hideRegister = hideAll || action !== 'register'

    function focus() {
        const eml = document.getElementById('email')
        const pwd = document.getElementById('pwd')
        if(eml.value) {
            pwd.focus()
            pwd.select()
        } else {
            eml.focus()
            eml.select()
        }
    }

	function login() {
        loading = true
        return post('/user/login', { email, password })
        .then(res => {
            loading = false
            if(res.status === 200) {
                onLogin(true)
            } else {
                switch(res.status) {
                    case 400: loginError = 'dados incompletos';     break;
                    case 401: loginError = 'senha expirada';        break;
                    case 403: loginError = 'senha inválida';        break;
                    case 404: loginError = 'usuário desconhecido';  break;
                    case 500: 
                        res.json().then(json => {
                            switch(json.violation) {
                                case 'UnknownUser'      : loginError = 'usuário desconhecido';  break;
                                case 'PasswordMismatch' : loginError = 'senha inválida';        break;
                            }
                        })
                        break
                }
                setTimeout(() => {
                    loginError = false
                    password   = null
                    focus()
                    onLogin(false)
                }, 3000)
            }
        })
        .catch(err => {
            loading = false
            focus()
            onLogin(false)
        })
    }

    function reset() {
        if(validate(email)) {
            loading = true
            return post('/user/password/reset', { email })
            .then(res => {
                loading = false
                if(res.status === 200) {
                    passwordResetError = false
                    passwordReset = true
                } else {
                    res.text().then(text => console.log('Erro: ' + text))
                    passwordResetError = true
                }
            })
            .catch(err => {
                passwordResetError = err
            })
        } else {
            errors['email'] = true
        }
    }

    function violationToReason(violation) {
        switch(violation) {
            case 'UserCreationError':
                errors.email = true
                return 'Usuário já existe'

            default: return violation
        }
    }

	function register() {
        if(validate(email)) {
            loading = true
            return post('/account', { email, name, promo })
            .then(res => {
                loading = false
                if(res.status === 200) {
                    accountCreated = true
                } else {
                    res .json()
                        .then(json => {
                            if(json.violation) {
                                reason = violationToReason(json.violation)

                                setTimeout(() => { reason = null }, 3000)
                            } else {
                                errors = {}
                                Object.keys(json).forEach(key => {
                                    console.log(key, json[key])
                                    errors[key] = json[key]
                                })
                            }
                        })
                        .catch(e => {
                            console.log(e)
                        })
                    // if (res.status == 400) {
                        
                    // } else if(res.status == 409) {
                    //     accountCreationError = true
                    // }
                }
            })
            .catch(err => {
                accountCreationError = err
            })
        } else {
            errors['email'] = true
        }
    }
</script>
<div class="container">
    <div class={accountCreated ? 'it created' : 'it hidden'}>
        <h1>Sua conta foi criada</h1>
        <h3>
            Um e-mail com um link de ativação foi enviado para o seu endereço de email.
        </h3>
    </div>
    <div class={passwordReset ? 'it created' : 'it hidden'}>
        <h1>Sua senha atual suspensa</h1>
        <h3>
            Um e-mail com um link de ativação foi enviado para o seu endereço de email.
        </h3>
    </div>

    <div class="it login" class:hideLogin>
        <div class="ui labeled big fluid input" 
             class:disabled={loading || loginError}>
            <div class="ui label">Email</div>
            <input id="email" type="text" bind:value={email} autocomplete="false">
        </div>
        <div class="ui labeled big fluid input"
             class:disabled={loading || loginError}>
            <div class="ui label">Senha</div>
            <input id="pwd" type="password" bind:value={password} autocomplete="false">
        </div>
        <button on:click={ login } 
                class:disabled={loading || loginError} 
                class:loading 
                class="ui blue big button">
            Login
        </button>
        {#if loginError}
            <div class="ui icon mini red message" transition:fade>
                <i class="ban icon"></i>
                <div class="content">
                    <div class="header">Erro</div>
                    <p>{ loginError }</p>
                </div>
            </div>        
        {/if}
        <div>
            <i on:click={e => { action = 'register' }} class="link">Criar conta</i> <br/>
            <i on:click={e => { action = 'reset'    }} class="link">Esqueci minha senha</i>
        </div>
    </div>

    <div class="it reset" class:hideReset>
        <div class="ui labeled big fluid input" 
             class:disabled={loading}
             class:error={errors['email']} >
            <div class="ui label">Email</div>
            <input type="text" bind:value={email} on:keydown={ e => errors['email'] = null } autocomplete="false">
            <div class="ui corner label error">
                <i class="asterisk icon"></i>
            </div>
        </div>
        {#if passwordResetError}
            <div class="ui big black inverted label">Erro</div>
        {/if}
        <button on:click={ reset } 
                class:disabled={loading} 
                class:loading 
                class="ui blue big button">
            Nova Senha
        </button>
        <div>
            <i on:click={e => { action = 'login' }} class="link">Voltar</i> <br/>
        </div>
    </div>

    <div class="it register" class:hideRegister>
        <div class="ui labeled big fluid input" 
             class:disabled={loading}
             class:error={errors['name']}>
            <div class="ui label">Nome</div>
            <input type="text" bind:value={name} on:keydown={ e => errors['name'] = null }>
            <div class="ui corner label error">
                <i class="asterisk icon"></i>
            </div>
        </div>
        <div class="ui labeled big fluid input" 
             class:disabled={loading}
             class:error={errors['email']}>
            <div class="ui label">Email</div>
            <input type="text" bind:value={email} on:keydown={ e => errors['email'] = null }>
            <div class="ui corner label error">
                <i class="asterisk icon"></i>
            </div>
        </div>
        <div class="ui labeled big fluid input promo" 
             class:disabled={loading}
             class:error={errors['promo']}>
            <div class="ui label">Código Promocional</div>
            <input type="text" bind:value={promo} on:keydown={ e => errors['promo'] = null }>
            <div class="ui corner label error">
                <i class="asterisk icon"></i>
            </div>
        </div>
        <button on:click={ register } 
                class:disabled={loading || reason} 
                class:loading 
                class="ui blue big button">Criar Conta</button>
        {#if reason}
            <div class="ui icon mini red message" transition:fade>
                <i class="ban icon"></i>
                <div class="content">
                    <div class="header">Erro</div>
                    <p>{ reason }</p>
                </div>
            </div>        
        {/if}
        <div>
            <i class="link" on:click={e => { action = 'login' }}>Voltar</i>
        </div>
    </div>
</div>
